<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";

  // props
  export let iconType: string = undefined;
  export let heading: string;

</script>

<style>
  .empty-table {
    margin-top: 2rem;
    text-align: center;
  }

</style>

<div class="fizz-justify-center fizz-stack-32 empty-table">
  {#if iconType !== undefined}
    <Icon
      type={iconType ? iconType : "Question"}
      height="64"
      width="64"
      centered
      extraClassNames={"fizz-stack-8"}
    />
  {/if}

  <strong class="padding--small">
    {heading}
  </strong>
  <div class="padding--smaller">
    <slot />
  </div>
</div>
